export default __webpack_public_path__ + "static/media/nidhu.e45cde3f.jpg";